import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { User, UserInfo } from '../../../models/types';
import { MarketPageService } from '../../services/market-page.service';

@Component({
  selector: 'app-all-users',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './all-users.component.html',
  styleUrl: './all-users.component.scss'
})
export class AllUsersComponent {

  constructor(private marketPageService: MarketPageService) {}

  allUsers: User[] = [];
  userCount: number = 0;

  ngOnInit() {
    this.fetchAllUsers();
  }

  fetchAllUsers() {
    this.marketPageService.getAllUsers().subscribe({
      next: (response) => {
        // Extract `all_users` from response body
        console.log('Response:', response);
        this.allUsers = response.all_users || [];
        this.userCount = this.allUsers.length;
        console.log('Users fetched:', this.allUsers);
      },
      error: (err) => {
        console.error('Error fetching users:', err);
        this.allUsers = [];
        this.userCount = 0;
      }
    });
  }

  deleteUser(userId: number) {
    this.marketPageService.deleteUser(userId).subscribe({
      next: (response) => {
        console.log('User deleted:', response);
        this.fetchAllUsers();
        window.location.reload();
      },
      error: (err) => {
        console.error('Error deleting user:', err);
      }
    });
  }

}
